import React from "react"

const Holiday = () => {
  return (
    <div
      style={{
        borderRadius: "20px",
        border: "1px solid #6C6C6C",
        background: "rgba(0, 0, 0, 0.10)",
        backdropFilter: "blur(12px)",
      }}
      className="text-white py-[18px] px-[28px]"
    >
      Holiday
    </div>
  )
}

export default Holiday
